import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const HarvestModalWrapper = styled(Modal)`
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
 
  ${'' /* .ant-input-number.ant-input-number-lg.ant-input-number-in-form-item {
    border: none;
    border-radius : 8px;
  }
  .ant-input-number.ant-input-number-lg.ant-input-number-in-form-item:hover{
    border:1px solid rgb(208, 213, 221) !important;
    border-radius : 0px;
  } */}
  .ant-form-item.isoInputWrapper{
    margin-bottom : 16px;
  }
  .btn-create-crop{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    padding: 8px;
    font-size: 12px;
    color: white;
    height: auto;
    width: auto
    border-radius: 8px;
    margin-top : 2rem;
  }
  .ant-modal-body{
    padding: 0;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  &.mob-cannot-create .ant-btn-primary{
    display: none;
  }
  .btn-create-breed{
    background-color: #46AFCA;
    border-color: #46AFCA;
    &:hover{
      opacity: 0.8;
    }
    margin-top:30px;
    width: 100%;
    padding: 0;
  }
  .card_content{
    display:inline;
  }

  .card_value{
    float:right;
  }

  .button-group{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    .action-button{
      height : 40px;
      border-color : #0B2A1B;
      color : #538c53;
    }
  }
`;

export default WithDirection(HarvestModalWrapper);